import { IValidationMessage } from './validationMessage.types'

/** class for Feedback */
export class ValidationMessage implements IValidationMessage {

    SectionKey: string
    SubSectionKey: string
    ItemKey: string
    Message: string    

    constructor (data: IValidationMessage) {
    
        this.SectionKey = data.SectionKey;
        this.SubSectionKey = data.SubSectionKey;
        this.ItemKey = data.ItemKey;    
        this.Message = data.Message;
    }
}